import type { LibraryDoc } from "@ideacrunch/shared";
import { useLibrary } from "../api";
import { MarkdownView } from "../components/bits";
import { useVocab } from "../vocab";

const GROUPS: { kind: LibraryDoc["kind"]; owner: string; user: string }[] = [
  { kind: "refuted", owner: "Refuted claims (registry)", user: "Dead claims" },
  { kind: "insights", owner: "Insights", user: "Insights" },
  { kind: "prospects", owner: "Prospects (scouted, unpicked)", user: "Idea backlog" },
  { kind: "domain", owner: "Domain notes", user: "Market notes" },
  {
    kind: "opinions",
    owner: "OPINIONS.md (human-owned)",
    user: "Your operating beliefs",
  },
];

export function LibraryPage() {
  const { data: docs, isLoading, error } = useLibrary();
  const { ownerMode } = useVocab();

  if (isLoading) return <div className="loading">Loading library...</div>;
  if (error) return <div className="error-box">{String(error)}</div>;

  return (
    <div>
      <h1 style={{ fontSize: 21 }}>Library</h1>
      <p style={{ color: "var(--ink-2)" }}>
        The compounding memory: every finished run deposits here, and every new
        run starts smarter because of it. A claim refuted once can never be
        re-argued for free.
      </p>
      {GROUPS.map((g) => {
        const groupDocs = (docs ?? []).filter((d) => d.kind === g.kind);
        if (groupDocs.length === 0) return null;
        return (
          <div key={g.kind}>
            <div className="section-label">{ownerMode ? g.owner : g.user}</div>
            {groupDocs.map((d) => (
              <details className="section-acc" key={d.relPath} open={g.kind !== "domain"}>
                <summary>
                  {d.title}{" "}
                  <span className="artifact-caption">{d.relPath}</span>
                </summary>
                <div className="panel">
                  {g.kind === "opinions" && (
                    <p className="parse-warnings">
                      Human-owned: agents propose, only you edit this file.
                    </p>
                  )}
                  <MarkdownView text={d.raw} collapsible />
                </div>
              </details>
            ))}
          </div>
        );
      })}
    </div>
  );
}
